"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModal = exports.Body = exports.Title = exports.Close = exports.Back = exports.Header = exports.ModalWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _reactSpring = require("react-spring");

var _icons = require("../../icons");

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Text = _interopRequireDefault(require("../../Text"));

var _Div = _interopRequireDefault(require("../../Div"));

var _styles = require("../../../shared/styles");

var _selectors = require("../../../shared/styles/themes/selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      ", "\n      ", " {\n        position: absolute;\n        ", "\n      }\n      ", " {\n        ", "\n      }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n      height: 100%;\n      max-width: 100%;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      width: calc(100% - 10px);\n      height: calc(100% - 10px);\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  ", "\n  width: calc(100% - 20px);\n  height: auto;\n  ", ";\n  ", ";\n  border-radius: ", ";\n  color: ", ";\n  background: ", ";\n  overflow: scroll;\n  max-height: 100%;\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  text-align: left;\n  align-self: center;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  color: inherit;\n  min-width: 30px;\n  min-height: 30px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  color: inherit;\n  min-width: 30px;\n  min-height: 30px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  z-index: 100;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  background-color: ", ";\n  z-index: 9999999;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalWrapper = (0, _styledComponents["default"])(_reactSpring.animated.div)(_templateObject(), function (props) {
  return (0, _polished.transparentize)(0.2, (0, _selectors.getField)('modal.overlayColor', props));
}, function (_ref) {
  var modalWrapperStyle = _ref.modalWrapperStyle;
  return modalWrapperStyle;
});
exports.ModalWrapper = ModalWrapper;
var Header = (0, _styledComponents["default"])(_Flex["default"])(_templateObject2(), (0, _styles.padding)('m', 'bottom'));
exports.Header = Header;
var Back = (0, _styledComponents["default"])(_icons.ChevronLeft)(_templateObject3());
exports.Back = Back;
var Close = (0, _styledComponents["default"])(_icons.CloseCircle)(_templateObject4());
exports.Close = Close;
var Title = (0, _styledComponents["default"])(_Text["default"]).attrs({
  weight: 'extrabold'
})(_templateObject5());
exports.Title = Title;
var Body = (0, _styledComponents["default"])(_Div["default"])(_templateObject6(), _styles.contentWrapper);
exports.Body = Body;
var StyledModal = (0, _styledComponents["default"])(_Div["default"])(_templateObject7(), _styles.contentWrapper, function (_ref2) {
  var fullScreen = _ref2.fullScreen;
  return fullScreen && (0, _styledComponents.css)(_templateObject8());
}, function (_ref3) {
  var page = _ref3.page;
  return page && (0, _styledComponents.css)(_templateObject9());
}, _styles.spacing.borderRadius.m, function (props) {
  return (0, _selectors.getField)('modal.color', props);
}, function (props) {
  return (0, _selectors.getField)('modal.backgroundColor', props);
}, (0, _styles.padding)('m'), function (_ref4) {
  var fullBody = _ref4.fullBody;
  return fullBody && (0, _styledComponents.css)(_templateObject10(), (0, _styles.padding)('none'), Header, (0, _styles.padding)('m'), Body, (0, _styles.margin)('none'));
}, _styles.addCssProp, function (_ref5) {
  var modalStyle = _ref5.modalStyle;
  return modalStyle;
});
exports.StyledModal = StyledModal;